import { Modal } from 'react-bootstrap';
import moment from 'moment';

const DisplayAgent = ({ show, hide, agent }) => {
  return (
    <div>
      <Modal
        size='md'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={show}
        onHide={hide}
      >
        <Modal.Header closeButton onClick={hide}>
          <h5>Agent Details</h5>
        </Modal.Header>
        <Modal.Body>
          <div className='ml-3'>
              <div>
                <h6>Names</h6>
                <p className='ml-2'>
                  {agent?.subscriber?.firstName} {agent?.subscriber?.lastName}
                </p>
              </div>
            <div
              style={{
                width: "100%",
                height: 1,
                backgroundColor: "#eee",
                marginBottom: 10,
              }}
            />
              <div>
                <h6>Phone Number</h6>
                <p className='ml-2'>{agent?.subscriber?.phoneNumber}</p>
              </div>
            <div
              style={{
                width: "100%",
                height: 1,
                backgroundColor: "#eee",
                marginBottom: 10,
              }}
            />
            <h6>Nation Id</h6>
            <p className='ml-2'>{agent?.subscriber?.nid || 'Not provided'}</p>
            <div
              style={{
                width: "100%",
                height: 1,
                backgroundColor: "#eee",
                marginBottom: 10,
              }}
            />
            <h6>type</h6>
            <p className='ml-2'>{agent?.type?.name}</p>
            <div
              style={{
                width: "100%",
                height: 1,
                backgroundColor: "#eee",
                marginBottom: 10,
              }}
            />
            <h6>Status</h6>
            <p className='ml-2'>{agent?.status?.name}</p>
            <div
              style={{
                width: "100%",
                height: 1,
                backgroundColor: "#eee",
                marginBottom: 10,
              }}
            />
            <h6>Created On</h6>
            <p className='ml-2'>
              {moment(agent?.createdAt).format("DD/MM/YYYY")}
            </p>
            <div
              style={{
                width: "100%",
                height: 1,
                backgroundColor: "#eee",
                marginBottom: 10,
              }}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default DisplayAgent